const infrastructureHosts = new Set([
  'origin.webfaster.online',
  'api-v3.webfaster.online',
])

const firstHeaderValue = (value: string | undefined): string | undefined => {
  const first = value?.split(',')[0]?.trim()
  return first || undefined
}

const parseHostname = (value: string | undefined): string | undefined => {
  const candidate = firstHeaderValue(value)
  if (!candidate) return undefined

  try {
    const url = candidate.includes('://') ? candidate : `https://${candidate}`
    return new URL(url).hostname.toLowerCase().replace(/\.$/, '')
  } catch {
    return undefined
  }
}

const isIpHostname = (hostname: string): boolean => {
  const unwrapped = hostname.replace(/^\[|\]$/g, '')
  return /^(?:\d{1,3}\.){3}\d{1,3}$/.test(unwrapped) ||
    (unwrapped.includes(':') && /^[0-9a-f:]+$/i.test(unwrapped))
}

const isInfrastructureHostname = (hostname: string): boolean =>
  infrastructureHosts.has(hostname) ||
  /(?:\.elb\.amazonaws\.com|\.compute\.amazonaws\.com|\.cloudfront\.net)$/i.test(hostname) ||
  /^(?:localhost|127\.0\.0\.1)$/i.test(hostname)

export const resolveTenantHost = (candidates: Array<string | undefined>): string => {
  for (const candidate of candidates) {
    const hostname = parseHostname(candidate)
    if (hostname && !isIpHostname(hostname) && !isInfrastructureHostname(hostname)) {
      return hostname
    }
  }

  return ''
}
